import styled from "styled-components";


export const NetUsbSection=styled.section`
    width: 100%;
`

export const NetUsbHeader=styled.p`
    margin: 0;
  padding: 0;
`


export const NetUsbContainer=styled.div`
    outline: 1px solid black;
  padding: 2px;
  margin: 5px 0 5px 0;
  min-height: 250px;
`

export const NetUsbArticle=styled.article`
  display: grid;
  grid-template-columns: 1fr 30px;
  align-items: center;
  gap: 10px;
  width: 100%;
  
  &:active {
    background-color: #0d6efd;
  }
`
export const NetUsbControlButton=styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  align-items: center;
`
